import { useMemo } from "react"
import { DiscoverResultsRow } from "./discover_results_row"
import { TooltipProvider } from "~/react/ui/tooltip"
import type { DiscoverDomain } from "~/react/types/discover"

interface DiscoverResultsTableProps {
  domains: DiscoverDomain[]
  domainsWithRecentFundings: number[]
  domainsCurrentlyHiring: number[]
  discoversPath: string
}

export function DiscoverResultsTable({
  domains,
  domainsWithRecentFundings,
  domainsCurrentlyHiring,
  discoversPath,
}: DiscoverResultsTableProps) {
  // Convert arrays to Sets for O(1) lookup performance
  const fundingsSet = useMemo(
    () => new Set(domainsWithRecentFundings),
    [domainsWithRecentFundings],
  )
  const hiringSet = useMemo(
    () => new Set(domainsCurrentlyHiring),
    [domainsCurrentlyHiring],
  )

  return (
    <TooltipProvider>
      <div
        className="h-table__scrollable"
        data-horizontal-scroll-position="start"
      >
        <table>
          <tbody>
            {domains.map((domain) => (
              <DiscoverResultsRow
                key={domain.id}
                domain={domain}
                hasRecentFunding={fundingsSet.has(domain.id)}
                isHiring={hiringSet.has(domain.id)}
                discoversPath={discoversPath}
              />
            ))}
          </tbody>
        </table>
      </div>
    </TooltipProvider>
  )
}
